import axios from "axios";
import { ip_back } from "../config";

const headers = () => ({
  headers: { Authorization: localStorage.getItem("token") },
});

function unwrap(response) {
  const body = response.data || {};
  if (body.status === "error") {
    throw new Error(body.message || "Request failed");
  }
  return body.data;
}

async function postHealth(path, payload) {
  try {
    const response = await axios.post(`${ip_back}api/admin${path}`, payload, headers());
    return unwrap(response);
  } catch (error) {
    const body = error.response?.data;
    if (body?.message) throw new Error(body.message);
    throw error;
  }
}

export async function saveHealthRecord(payload) {
  return postHealth("/healthRecord", payload);
}

export async function saveHealthAttendance(payload) {
  return postHealth("/healthAttendance", payload);
}

export async function listHealthRecords(grId) {
  return postHealth("/healthRecords", { gr_id: grId });
}
